<template>
  <excel-export
    :data="items"
    :fields="excelFields"
    worksheet="Documentos"
    name="documentos_compliance.xlsx"
  />
</template>

<script>
import ExcelExport from '@/components/shared/ExcelExport.vue';
import { formatDateTime, formatVisitor } from '@/plugins/complianceScripts';

export default {
  name: 'DocumentReportExcel',

  components: {
    ExcelExport
  },

  props: {
    items: Array
  },

  computed: {
    excelFields() {
      return {
        'Documento': 'name',
        'Confidencial': {
          field: 'confidential',
          callback: value => value ? 'Sí' : 'No',
          widht: 15
        },
        'Tipo de documento': {
          field: 'type',
          callback: value => value.name,
          widht: 25
        },
        'Fecha creación': {
          field: 'creationDate',
          callback: formatDateTime,
          width: 25
        },
        'Destinatarios': {
          field: 'rolesDestinations',
          callback: value => value.map(dest => dest.name).join(', '),
          width: 60
        },
        'Visitantes': {
          field: 'visitors',
          callback: value => value.map(visitor => formatVisitor(visitor)).join(', '),
          width: 60
        },
        'Usuarios sin visualizar': {
          field: 'nonVisitors',
          callback: value => value
            ? value.map(x => x.visitorMail).join(', ')
            : '',
          width: 60
        }
      };
    }
  }
};
</script>